import Image from 'next/image';

interface WhatWeGrowProps {
  className?: string;
}

const WhatWeGrow = ({ className = '' }: WhatWeGrowProps) => {
  return (
    <section className={`py-20 bg-surface ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-3 py-1 bg-brand-primary/10 rounded-full mb-6">
            <span className="text-sm font-semibold text-brand-primary">What We're Growing</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl font-bold text-text-primary mb-4">
            Fresh Produce from Our Hydroponic Programs
          </h2>
          
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our students grow a diverse variety of nutritious vegetables including lettuce, mustard, cabbage, peppers, tomatoes, herbs, sweet potatoes, green beans, okra, legumes, and chard.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="relative h-[500px] sm:h-[600px] rounded-2xl overflow-hidden shadow-brand-lg bg-white">
            <Image
              src="/assets/images/Screenshot_2026-02-05_at_5.29.42_PM-1770330699882.png"
              alt="Illustration of various vegetables grown in hydroponic programs including lettuce, mustard, cabbage, peppers, tomatoes, herbs, sweet potatoes, green beans, okra, legumes, and chard"
              fill
              unoptimized
              className="object-contain"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeGrow;